module.exports = __webpack_public_path__ + "img/heat.b91aa2bb.png";